// extracted by mini-css-extract-plugin
module.exports = {"section":"_en","sectionContainer":"_eo","sectionButton":"_ep","title":"_eq","card":"_er"};